<template>
  <section v-if="!hideHeaderAndFooter">
    <!-- sağda göstere tıklayınca eklenecek class 'sidebarRight' -->
    <nav class="sidebarMenu" :class="sidebarRightClass ? 'sidebarRight' : null">
      <div class="sidebarSticky">
        <div class="row no-gutters">
          <div class="col-12">
            <!-- direction button -->
            <div class="dropdown directionMenuDropdown">
              <button
                class="btn btnDirection dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                role="combobox"
                aria-haspopup="listbox"
                aria-expanded="false"
              />
              <div class="dropdown-menu">
                <!-- aktif olana gelecek class 'active' -->
                <button
                  type="button"
                  class="dropdown-item"
                  :class="activeDirectionMenu === 'menuLeft' ? 'active' : null"
                  @click="quickMenuDirection('menuLeft')"
                >
                  Solda Göster
                </button>
                <button
                  type="button"
                  class="dropdown-item"
                  :class="activeDirectionMenu === 'menuRight' ? 'active' : null"
                  @click="quickMenuDirection('menuRight')"
                >
                  Sağda Göster
                </button>
              </div>
            </div>
            <!--<button type="button" class="btn btnDirection"></button>-->
            <!-- menu -->
            <ul>
              <li class="nav">
                <router-link
                  v-b-tooltip="{
                    customClass: 'tooltipContainer',
                    placement: 'right',
                    html: true,
                    title: 'Anasayfa',
                  }"
                  tag="a"
                  to="/"
                  class="nav-link"
                  :class="{ active: sidebarActiveClass === 'anasayfa' }"
                  exact
                  @click.native="sidebarActiveClass = 'anasayfa'"
                >
                  <img
                    v-if="sidebarActiveClass === 'anasayfa'"
                    :src="require('../../../public/src/images/icon-sidebar-home-white.svg')"
                    alt="icon-sidebar-home-white"
                  />
                  <img v-else :src="require('../../../public/src/images/icon-sidebar-home.svg')" alt="icon-sidebar-home" />
                </router-link>
              </li>
            </ul>
            <!-- YTP-10380 birlesik rail: kategori + kisayol tek listede, serbestce surukle-sirala -->
            <draggable
              v-if="railItems.length"
              v-model="railItems"
              tag="ul"
              class="railOthersList"
              :animation="200"
              @end="onRailReorder"
            >
              <li v-for="item in railItems" :key="item.id" class="nav railOtherItem">
                <!-- kategori ikonu: grid filtreler -->
                <router-link
                  v-if="item.type === 'category'"
                  v-b-tooltip="{ customClass: 'tooltipContainer', placement: 'right', html: true, title: item.title }"
                  tag="a"
                  to="/"
                  class="nav-link"
                  :class="{ active: sidebarActiveClass === item.key }"
                  exact
                  @click.native="sidebarActiveClass = item.key"
                >
                  <img :src="railIcon(item)" :alt="item.key" />
                </router-link>
                <!-- kisayol grubu: kategori gibi, tiklayinca gruptaki menuleri grid'de acar -->
                <router-link
                  v-else
                  v-b-tooltip="{ customClass: 'tooltipContainer', placement: 'right', html: true, title: item.name }"
                  tag="a"
                  to="/"
                  class="nav-link"
                  :class="{ active: sidebarActiveClass === 'qmg:' + item.groupId }"
                  exact
                  @click.native="sidebarActiveClass = 'qmg:' + item.groupId"
                >
                  <span class="quickMenuInitials" :style="{ background: item.bg || 'var(--light-royal-blue)' }">
                    <i v-if="item.icon" :class="['fas', 'fa-' + item.icon]" :style="{ color: item.color || '#fff' }" />
                    <span v-else :style="{ color: item.color || '#fff' }">{{ quickMenuInitials(item.name) }}</span>
                  </span>
                </router-link>
                <!-- YTP-10488 duzenle (kalem): sadece kisayol gruplari -->
                <button
                  v-if="item.type === 'shortcut'"
                  type="button"
                  class="btn btnRailEdit"
                  aria-label="Grubu düzenle"
                  @click.stop="openEditQuickGroup(item)"
                >
                  <i class="fas fa-pen" />
                </button>
                <!-- silme: kategori -> gizle, kisayol grubu -> hizli menuden cikar -->
                <button
                  type="button"
                  class="btn btnRailRemove"
                  aria-label="Menüden kaldır"
                  @click.stop="item.type === 'category' ? removeSidebarItem(item.key) : removeQuickGroup(item.groupId)"
                >
                  ✕
                </button>
              </li>
            </draggable>
            <!-- hr -->
            <hr class="customHr" />
            <!-- YTP-10380 kisayol ekle butonu: ikonlarin hemen altinda (eskiden en altta pinliydi) -->
            <button type="button" class="btn btnAddSidebarMenu" @click="openQuickMenuModal()">
              <img src="../../../public/src/images/icon-btn-add-white-plus.svg" alt="" />
            </button>
          </div>
        </div>
      </div>
    </nav>
    <!-- modal start -->
    <!-- quick menu modal -->
    <div id="quickMenuModal" class="modal fade righToLeftModal customModal" tabindex="-1" aria-labelledby="quickMenuModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editingGroupId ? "Menü Grubunu Düzenle" : "Hızlı Menü" }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
            </button>
          </div>
          <div class="modal-body quickMenu">
            <!-- text -->
            <div class="row">
              <div class="col-sm-11">
                <p class="textQuickMenu">
                  Sık kullandığınız menülerden <b>birden fazla</b> seçerek kendi menü grubunuzu oluşturabilirsiniz. Kısayola tıkladığınızda seçtiğiniz
                  menüler ana ekranda listelenir.
                </p>
              </div>
            </div>
            <!-- YTP-10488 hedef menuler (yetkili menulerden aranabilir COKLU secim) + grup adi -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>Menüler <small class="text-muted">({{ newQuickMenuTargets.length }} seçili)</small></label>
                  <input v-model="targetSearch" type="text" class="form-control" placeholder="Menü ara..." />
                  <div class="quickMenuTargetList">
                    <button
                      v-for="menu in filteredAuthorizedMenus"
                      :key="'qmtarget-' + menu.tag"
                      type="button"
                      class="btn btn-block text-left quickMenuTargetRow"
                      :class="{ active: isTargetSelected(menu) }"
                      @click="toggleQuickMenuTarget(menu)"
                    >
                      <i class="fa mr-2" :class="isTargetSelected(menu) ? 'fa-check' : 'fa-plus'"></i>{{ menu.name }}
                    </button>
                    <p v-if="filteredAuthorizedMenus.length === 0" class="quickMenuTextDanger mb-0">Eklenebilecek menü bulunamadı.</p>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label>Grup Adı</label>
                  <input
                    v-model="newQuickMenuName"
                    type="text"
                    class="form-control"
                    placeholder="Kısayol / grup adı"
                    maxlength="40"
                  />
                </div>
              </div>
            </div>
            <!-- icon (YTP-10380: ikon/renk secimi Faz 5b/5c'de aktive edilecek) -->
            <div v-if="false" class="row">
              <!-- text -->
              <div class="col-12">
                <div class="form-group">
                  <label for="inputText">İcon Seçiniz</label>
                  <!-- bu yazı hep kalacak -->
                  <p class="quickMenuTextDanger">İcon seçimi yapılmadığı zaman kategorinizin baş harfleri kullanılacaktır.</p>
                </div>
              </div>
              <!-- icon box area  -->
              <div class="col-12">
                <div class="iconBoxArea">
                  <div class="row customRow15">
                    <!-- her zaman seçili olarak (default) gelecek icon (kategori baş harfleri) olacak -->
                    <div class="col-sm-3 customPadding15">
                      <button type="button" class="btn btnIconText active">İ.T.</button>
                      <!-- <button type="button" class=" btn btnIcon"></button> -->
                    </div>
                    <template v-for="(iconName, index) in iconNames">
                      <div v-if="iconName !== 'font-awesome-logo-full'" :key="'iconName-' + index" class="col-sm-3 customPadding15">
                        <!-- icon zemin rengi seçilince burda class eklenecek 'bg-success' örnek olarak -->
                        <button type="button" class="btn btnIconText">
                          <!--burda style ile yazmamızın sebebi fontawesome iconları bu şekilde renk değiştiriyor-->
                          <!-- aşağıdan icon rengine basınca 'style="color:#065dea"' style etiketi ile bu şekilde eklenecek hangi renk ise -->
                          <i :class="['fas', 'fa-' + iconName]" />
                          <!--solid-->
                          <!--<i :class="['fas', 'fa-'+iconName]"></i>-->
                          <!--<span>{{ iconName }}</span>-->
                        </button>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <!-- icon color and preview -->
              <div class="col-12">
                <div class="row customRow15">
                  <!-- icon color area -->
                  <div class="col-sm-6 customPadding15">
                    <!-- text -->
                    <div class="form-group d-flex align-items-center justify-content-between">
                      <label for="inputText" class="mb-0">İcon Rengi</label>
                      <button
                        v-b-tooltip="{
                          customClass: 'tooltipContainer',
                          placement: 'top',
                          html: true,
                          title: 'İcon rengi seçimi yapılmazsa default renkler kullanılacaktır.',
                        }"
                        type="button"
                        class="btn btnIconTooltip"
                      >
                        i
                      </button>
                    </div>
                    <!-- icon color button -->
                    <div class="row customRow15">
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-info" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-pink disabled" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-peachyPink active" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-success" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-warning" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-orange" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-dark" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-danger" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-grey" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-primary" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-secondary" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-lightPeriwinkle" />
                      </div>
                    </div>
                    <!-- ------ -->
                    <!-- icon background color -->
                    <!-- text -->
                    <div class="form-group d-flex align-items-center justify-content-between">
                      <label for="inputText" class="mb-0">İcon Zemin Rengi</label>
                      <button
                        v-b-tooltip="{
                          customClass: 'tooltipContainer',
                          placement: 'top',
                          html: true,
                          title: 'İcon zemin rengi seçimi yapılmazsa default renkler kullanılacaktır.',
                        }"
                        type="button"
                        class="btn btnIconTooltip"
                      >
                        i
                      </button>
                    </div>
                    <!-- icon color button -->
                    <div class="row customRow15">
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-info" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-pink disabled" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-peachyPink active" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-success" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-warning" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-orange" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-dark" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-danger" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-grey" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-primary" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-secondary" />
                      </div>
                      <div class="col-sm-3 customPadding15">
                        <button type="button" class="btn btnIcon bg-lightPeriwinkle" />
                      </div>
                    </div>
                  </div>
                  <!-- icon preview area -->
                  <div class="col-sm-6 customPadding15">
                    <!-- text -->
                    <div class="form-group d-flex align-items-center">
                      <label for="inputText" class="mb-0">İcon Rengi</label>
                    </div>
                    <section class="iconPreviewArea">
                      <span class="iconImg">
                        <img src="../../../public/src/images/icon-add-feature-star.svg" alt="icon-add-feature-star" class="img-fluid" />
                      </span>
                    </section>
                  </div>
                  <!-- text warning -->
                  <!-- burası eğer aynı renkleri seçerse gözükecek -->
                  <div class="col-12 customPadding15">
                    <p class="quickMenuTextDanger">İcon rengi ile zemin rengi aynı olamaz. Lütfen farklı bir zemin rengi seçiniz.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- YTP-10380 islevsel ikon + renk secimi + onizleme -->
            <div class="row quickMenuCustomize">
              <div class="col-12">
                <div class="form-group">
                  <label>İkon</label>
                  <p class="quickMenuTextDanger mb-2">İkon seçilmezse menü adının baş harfleri kullanılır.</p>
                  <div class="quickMenuIconGrid">
                    <button
                      type="button"
                      class="btn quickMenuIconOption"
                      :class="{ active: !newQuickMenuIcon }"
                      @click="newQuickMenuIcon = null"
                    >
                      {{ previewInitials }}
                    </button>
                    <button
                      v-for="icon in pickableIcons"
                      :key="'qmicon-' + icon"
                      type="button"
                      class="btn quickMenuIconOption"
                      :class="{ active: newQuickMenuIcon === icon }"
                      @click="newQuickMenuIcon = icon"
                    >
                      <i :class="['fas', 'fa-' + icon]" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label>İkon Rengi</label>
                  <div class="quickMenuColorRow">
                    <button
                      v-for="c in colorPalette"
                      :key="'qmcolor-' + c"
                      type="button"
                      class="btn quickMenuColorDot"
                      :class="{ active: newQuickMenuColor === c }"
                      :style="{ background: c }"
                      @click="newQuickMenuColor = c"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label>Zemin Rengi</label>
                  <div class="quickMenuColorRow">
                    <button
                      v-for="c in colorPalette"
                      :key="'qmbg-' + c"
                      type="button"
                      class="btn quickMenuColorDot"
                      :class="{ active: newQuickMenuBg === c }"
                      :style="{ background: c }"
                      @click="newQuickMenuBg = c"
                    />
                  </div>
                </div>
              </div>
              <div v-if="quickMenuColorConflict" class="col-12">
                <p class="quickMenuTextDanger">İkon rengi ile zemin rengi aynı olamaz. Lütfen farklı bir renk seçiniz.</p>
              </div>
              <div class="col-12">
                <label>Önizleme</label>
                <div class="quickMenuPreview">
                  <span class="quickMenuPreviewTile" :style="{ background: previewBg }">
                    <i v-if="newQuickMenuIcon" :class="['fas', 'fa-' + newQuickMenuIcon]" :style="{ color: previewIconColor }" />
                    <span v-else :style="{ color: previewIconColor }">{{ previewInitials }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="row">
              <div class="col-6">
                <button type="button" class="btn btn-secondary w-100" data-dismiss="modal">Kapat</button>
              </div>
              <div class="col-6">
                <button type="button" class="btn btn-primary w-100" :disabled="!newQuickMenuTargets.length || quickMenuColorConflict" @click="confirmCreateQuickMenu()">
                  {{ editingGroupId ? "Güncelle" : "Ekle" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//font awesome start
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// import {far} from '@fortawesome/free-regular-svg-icons';
//font awesome end
import draggable from "vuedraggable";
import enumHelper from "../../util/enumHelper";
export default {
  name: "BaseQuickMenuSidebar",
  components: { draggable },
  data() {
    return {
      iconNames: [],
      sidebarRightClass: false,
      activeDirectionMenu: "menuLeft",
      // YTP-10380 sabit kategori rail'i (data-driven). "anasayfa" = Ana menu, silinemez/tasinmaz.
      defaultSidebarItems: [
        { key: "anasayfa", title: "Anasayfa", icon: "icon-sidebar-home.svg", iconActive: "icon-sidebar-home-white.svg" },
        { key: "birimPersonelYonetimi", title: "Birim - Personel Yönetimi", icon: "icon-sidebar-user-management.svg", iconActive: "icon-sidebar-user-management-white.svg" },
        { key: "yoneticiIslemleri", title: "Yönetici İşlemleri", icon: "icon-sidebar-admin-operations.svg", iconActive: "icon-sidebar-admin-operations-white.svg" },
        { key: "satisIslemleri", title: "Satış İşlemleri", icon: "icon-sidebar-sales-transactions.svg", iconActive: "icon-sidebar-sales-transactions-white.svg" },
        { key: "fiyatlandirma", title: "Fiyatlandirma", icon: "icon-sidebar-pricing.svg", iconActive: "icon-sidebar-pricing-white.svg" },
        { key: "giseIslemleri", title: "Gişe İslemleri", icon: "icon-sidebar-information.svg", iconActive: "icon-sidebar-information-white.svg" },
        { key: "acenteIslemleri", title: "Acente Yönetimi", icon: "icon-sidebar-agency-management.svg", iconActive: "icon-sidebar-agency-management-white.svg" },
        { key: "yolcuIslemleri", title: "Yolcu İşlemleri", icon: "icon-sidebar-after-sales-operations.svg", iconActive: "icon-sidebar-after-sales-operations-white.svg" },
      ],
      // YTP-10488 quickMenuModal (cok-menulu grup olustur/duzenle)
      newQuickMenuName: "",
      newQuickMenuTargets: [],
      editingGroupId: null,
      targetSearch: "",
      newQuickMenuIcon: null,
      newQuickMenuColor: null,
      newQuickMenuBg: null,
      // YTP-10380 birlesik rail yerel dizisi (kategori + kisayol; store'dan senkron, @end ile kaydedilir)
      railItems: [],
      // ikon/zemin renk paleti (deger dogrudan style'a uygulanir)
      colorPalette: [
        "#2f6fed",
        "#7b61ff",
        "#e04b4b",
        "#12b76a",
        "#f79009",
        "#0ba5ec",
        "#667085",
        "#1d2939",
        "#d444f1",
        "#ffffff",
      ],
      // secilebilir fontawesome ikonlari (tam liste cok buyuk oldugundan kurath alt kume)
      pickableIcons: [
        "home", "star", "bell", "user", "users", "cog", "list", "table",
        "calendar", "clock", "folder", "file", "tag", "ticket-alt", "train",
        "subway", "map-marker-alt", "search", "envelope", "phone", "print",
        "sync", "database", "sitemap", "id-card", "money-bill", "receipt",
        "clipboard-list", "tasks", "bookmark", "flag", "bolt", "wrench", "chart-bar",
      ],
    };
  },
  computed: {
    sidebarActiveClass: {
      get() {
        return this.$store.getters.getSidebarActiveClass;
      },
      set(value) {
        this.$store.commit("setSidebarActiveClass", value);
      },
    },
    hideHeaderAndFooter: {
      get() {
        if (this.$route.meta.hideHeaderAndFooter) {
          return this.$route.meta.hideHeaderAndFooter;
        } else {
          return false;
        }
      },
      set(val) {
        val = false;
      },
    },
    // YTP-10380 kullanicinin yetkili oldugu izin tag'leri (hizli menuyu suzmek icin)
    permittedTags() {
      return new Set((this.$store.getters.getUserResources || []).map((r) => r.tag));
    },
    // YTP-10488 hizli menu ARTIK cok-menulu grup: her oge {groupId, name, icon, color, bg, items:[{tag,name,route}]}.
    // Eski tek-hedef kayitlari ({tag,name,route}) tek-ogeli gruba normalize edilir. items yetkiyle suzulur;
    // yetkili en az bir menusu olmayan grup gizlenir.
    quickMenuGroups() {
      return (this.$store.getters.getUiQuickMenu || [])
        .map((q) => {
          const rawItems = Array.isArray(q.items) ? q.items : [{ tag: q.tag, name: q.name, route: q.route }];
          const items = rawItems.filter((it) => it && it.tag && this.permittedTags.has(it.tag));
          return {
            groupId: q.id || "legacy:" + (q.tag || q.name || ""),
            name: q.name,
            icon: q.icon || null,
            color: q.color || null,
            bg: q.bg || null,
            items,
          };
        })
        .filter((g) => g.items.length > 0);
    },
    // YTP-10380 birlesik rail: Anasayfa haricindeki tum ikonlar (kategori + kisayol grubu) tek listede.
    // id: "cat:<key>" | "qm:<groupId>". Kayitli birlesik sira (sidebar.railOrder) uygulanir; yeni ogeler sona eklenir.
    // Gizlenen kategoriler (sidebar.hidden) ve yetkisiz gruplar listede gorunmez.
    unifiedRailItems() {
      const sidebar = this.$store.getters.getUiSidebar || {};
      const hidden = new Set(sidebar.hidden || []);
      const railOrder = sidebar.railOrder || [];
      const available = {};
      this.defaultSidebarItems.forEach((it) => {
        if (it.key === "anasayfa" || hidden.has(it.key)) return;
        available["cat:" + it.key] = { ...it, type: "category", id: "cat:" + it.key };
      });
      this.quickMenuGroups.forEach((g) => {
        available["qm:" + g.groupId] = { ...g, type: "shortcut", id: "qm:" + g.groupId };
      });
      const result = [];
      const used = new Set();
      railOrder.forEach((id) => {
        if (available[id] && !used.has(id)) {
          result.push(available[id]);
          used.add(id);
        }
      });
      // railOrder'da olmayan yeni ogeler: once kategoriler (varsayilan sira), sonra kisayol gruplari
      this.defaultSidebarItems.forEach((it) => {
        const id = "cat:" + it.key;
        if (it.key !== "anasayfa" && available[id] && !used.has(id)) {
          result.push(available[id]);
          used.add(id);
        }
      });
      this.quickMenuGroups.forEach((g) => {
        const id = "qm:" + g.groupId;
        if (available[id] && !used.has(id)) {
          result.push(available[id]);
          used.add(id);
        }
      });
      return result;
    },
    // YTP-10380 quickMenuModal: kullanicinin yetkili oldugu tum yaprak menuler (ad + route + tag), alfabetik (TR)
    authorizedMenus() {
      const roots = Object.values(enumHelper.MyPages).filter((v) => v && typeof v === "object" && Array.isArray(v.children));
      return this.flattenTree(roots)
        .filter((it) => it.route && it.route !== "" && this.permittedTags.has(it.pagePermissionTag))
        .map((it) => ({ name: it.name, route: it.route, tag: it.pagePermissionTag }))
        .sort((a, b) => (a.name || "").localeCompare(b.name || "", "tr"));
    },
    // YTP-10488 arama filtresi (gruplar cakisabilir; "zaten eklenmis" harici YOK)
    filteredAuthorizedMenus() {
      const query = (this.targetSearch || "").trim().toLocaleLowerCase("tr-TR");
      if (!query) return this.authorizedMenus;
      return this.authorizedMenus.filter((m) => m.name.toLocaleLowerCase("tr-TR").includes(query));
    },
    // onizleme: grup adindan (yoksa ilk secili menuden) bas harf, secili renk/zemin
    previewInitials() {
      const first = this.newQuickMenuTargets[0];
      return this.quickMenuInitials(this.newQuickMenuName || (first && first.name));
    },
    previewBg() {
      return this.newQuickMenuBg || "var(--light-royal-blue)";
    },
    previewIconColor() {
      return this.newQuickMenuColor || "#ffffff";
    },
    // ikon rengi ile zemin rengi ayni olmasin
    quickMenuColorConflict() {
      return !!this.newQuickMenuColor && this.newQuickMenuColor === this.newQuickMenuBg;
    },
  },
  watch: {
    // YTP-10380 store'daki sira/gizleme/kisayol degisince birlesik rail'i yeniden kur
    unifiedRailItems: {
      handler() {
        this.railItems = [...this.unifiedRailItems];
      },
      immediate: true,
    },
  },
  mounted() {
    this.getAllFontAwesomeIcon();
  },
  methods: {
    getAllFontAwesomeIcon() {
      // library.add(far);
      // solid
      library.add(fas);
      // css ile iconları oluşturuyor
      dom.css();
      this.iconNames = Object.keys(library.definitions.fas);
      // this.iconNames = Object.keys(library.definitions.far);
    },
    quickMenuDirection(param) {
      const customContainerFluidClass = document.querySelector(".customContainerFluid");
      if (param === "menuRight") {
        this.sidebarRightClass = true;
        this.activeDirectionMenu = "menuRight";
        // app.vue içerisindeki customContainerFluid alanı
        customContainerFluidClass.classList.add("containerFluidRight");
      } else if (param === "menuLeft") {
        this.sidebarRightClass = false;
        this.activeDirectionMenu = "menuLeft";
        // app.vue içerisindeki customContainerFluid alanı
        customContainerFluidClass.classList.remove("containerFluidRight");
      }
      this.quickMenuClickEvent();
    },
    quickMenuClickEvent() {
      let quickMenuPosition = {
        sidebarRightClass: this.sidebarRightClass,
        activeDirectionMenu: this.activeDirectionMenu,
      };
      this.$emit("quickMenuClickEvent", quickMenuPosition);
    },
    // YTP-10488 hizli menu grubunu sil (grup id ile; eski tek-hedef kayitlari da "legacy:<tag>" ile eslesir)
    removeQuickGroup(groupId) {
      const quickMenu = (this.$store.getters.getUiQuickMenu || []).filter((q) => {
        const id = q.id || "legacy:" + (q.tag || q.name || "");
        return id !== groupId;
      });
      this.$store.dispatch("saveUiSettings", { quickMenu });
    },
    quickMenuInitials(name) {
      if (!name) return "?";
      const words = String(name).trim().split(/\s+/).filter(Boolean);
      const letters = words.slice(0, 2).map((w) => w.charAt(0));
      return letters.join("").toLocaleUpperCase("tr-TR");
    },
    // YTP-10380 rail ikonu (aktifse beyaz varyant)
    railIcon(item) {
      const name = this.sidebarActiveClass === item.key ? item.iconActive : item.icon;
      return require("../../../public/src/images/" + name);
    },
    // YTP-10380 birlesik rail surukle-birak bittiginde yeni sirayi kaydet
    // (kategori + kisayol tek listede; id sirasi sidebar.railOrder'a yazilir)
    onRailReorder() {
      const railOrder = this.railItems.map((it) => it.id);
      const sidebar = this.$store.getters.getUiSidebar || {};
      this.$store.dispatch("saveUiSettings", { sidebar: { ...sidebar, railOrder } });
    },
    // YTP-10380 sabit kategori ikonunu gizle (Ana menu/anasayfa haric)
    removeSidebarItem(key) {
      if (key === "anasayfa") return;
      const sidebar = this.$store.getters.getUiSidebar || {};
      const hidden = Array.isArray(sidebar.hidden) ? [...sidebar.hidden] : [];
      if (!hidden.includes(key)) hidden.push(key);
      this.$store.dispatch("saveUiSettings", { sidebar: { ...sidebar, hidden } });
    },
    // YTP-10380 enumHelper menu agacini yaprak listesine duzlestir
    flattenTree(tree) {
      let flat = [];
      (tree || []).forEach((item) => {
        flat.push(item);
        if (item.children && item.children.length > 0) {
          flat = flat.concat(this.flattenTree(item.children));
        }
      });
      return flat;
    },
    // YTP-10488 quickMenuModal ac (yeni grup) / coklu hedef sec / grup olustur-guncelle
    openQuickMenuModal() {
      this.editingGroupId = null;
      this.newQuickMenuName = "";
      this.newQuickMenuTargets = [];
      this.targetSearch = "";
      this.newQuickMenuIcon = null;
      this.newQuickMenuColor = null;
      this.newQuickMenuBg = null;
      this.$nextTick(() => $("#quickMenuModal").modal("show"));
    },
    // YTP-10488 var olan grubu duzenle: modal'i grubun mevcut degerleriyle ac
    openEditQuickGroup(group) {
      this.editingGroupId = group.groupId;
      this.newQuickMenuName = group.name || "";
      this.newQuickMenuTargets = (group.items || []).map((it) => ({ tag: it.tag, name: it.name, route: it.route }));
      this.targetSearch = "";
      this.newQuickMenuIcon = group.icon || null;
      this.newQuickMenuColor = group.color || null;
      this.newQuickMenuBg = group.bg || null;
      this.$nextTick(() => $("#quickMenuModal").modal("show"));
    },
    isTargetSelected(menu) {
      return this.newQuickMenuTargets.some((t) => t.tag === menu.tag);
    },
    toggleQuickMenuTarget(menu) {
      const idx = this.newQuickMenuTargets.findIndex((t) => t.tag === menu.tag);
      if (idx === -1) {
        this.newQuickMenuTargets.push({ tag: menu.tag, name: menu.name, route: menu.route });
        if (!this.newQuickMenuName && this.newQuickMenuTargets.length === 1) {
          this.newQuickMenuName = menu.name;
        }
      } else {
        this.newQuickMenuTargets.splice(idx, 1);
      }
    },
    generateId() {
      return "g" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    },
    confirmCreateQuickMenu() {
      if (!this.newQuickMenuTargets.length || this.quickMenuColorConflict) return;
      const name = (this.newQuickMenuName || this.newQuickMenuTargets[0].name).trim();
      const fields = {
        name,
        icon: this.newQuickMenuIcon || null,
        color: this.newQuickMenuColor || null,
        bg: this.newQuickMenuBg || null,
        items: this.newQuickMenuTargets.map((t) => ({ tag: t.tag, name: t.name, route: t.route })),
      };
      const store = this.$store.getters.getUiQuickMenu || [];
      let quickMenu;
      if (this.editingGroupId) {
        // mevcut grubu guncelle (id + rail konumu korunur)
        quickMenu = store.map((q) => {
          const id = q.id || "legacy:" + (q.tag || q.name || "");
          return id === this.editingGroupId ? { id: this.editingGroupId, ...fields } : q;
        });
      } else {
        quickMenu = [...store, { id: this.generateId(), ...fields }];
      }
      this.$store.dispatch("saveUiSettings", { quickMenu });
      this.editingGroupId = null;
      $("#quickMenuModal").modal("hide");
    },
  },
};
</script>

<style scoped lang="scss">
.tooltipContainer {
  opacity: 1 !important;

  .tooltip-inner {
    text-align: left;
  }
}
/* YTP-10380 kisayol rozeti .nav kutusunu (50x50) tamamen doldursun ki kategori ikonlariyla ayni boyda olsun */
.railOtherItem .nav-link .quickMenuInitials {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: var(--light-royal-blue);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  .fas {
    font-size: 18px;
  }
}
/* YTP-10380 birlesik rail (kategori + kisayol): hover'da silme */
.railOthersList {
  list-style: none;
  padding: 0;
  margin: 0;
}
.railOtherItem {
  position: relative;
}
/* anasayfa kendi ul'unda :last-child (mb:0) oldugundan ilk kategoriye ust bosluk ver */
.railOtherItem:first-child {
  margin-top: 8px;
}
.btnRailRemove {
  position: absolute;
  top: -2px;
  right: 2px;
  padding: 0;
  width: 16px;
  height: 16px;
  line-height: 1;
  font-size: 11px;
  color: #fff;
  background: #e04b4b;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 2;
}
.railOtherItem:hover .btnRailRemove {
  opacity: 1;
}
/* YTP-10488 grup duzenle (kalem) - sol ustte, hover'da gorunur */
.btnRailEdit {
  position: absolute;
  top: -2px;
  left: 2px;
  padding: 0;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  font-size: 8px;
  color: #fff;
  background: var(--light-royal-blue);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 2;
}
.railOtherItem:hover .btnRailEdit {
  opacity: 1;
}
/* YTP-10380 quickMenuModal hedef sayfa listesi */
.quickMenuTargetList {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  padding: 6px;
  margin-top: 6px;
}
.quickMenuTargetRow {
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 4px;
  &:hover {
    background: #eef3ff;
  }
  &.active {
    background: #eef3ff;
    border-color: var(--light-royal-blue);
    font-weight: 600;
  }
}
/* YTP-10380 quickMenuModal ikon + renk secimi + onizleme */
.quickMenuCustomize {
  margin-top: 8px;
  label {
    font-weight: 600;
  }
}
.quickMenuIconGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 168px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
}
.quickMenuIconOption {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  background: #f9fafb;
  font-size: 15px;
  font-weight: 700;
  color: #475467;
  &:hover {
    background: #eef3ff;
  }
  &.active {
    border-color: var(--light-royal-blue);
    background: #eef3ff;
    box-shadow: 0 0 0 1px var(--light-royal-blue) inset;
  }
}
.quickMenuColorRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.quickMenuColorDot {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #d0d5dd;
  padding: 0;
  &.active {
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--light-royal-blue);
  }
}
.quickMenuPreview {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.quickMenuPreviewTile {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
}
</style>
